import { useContext, createContext, ReactNode } from 'react';

import { ERegionCode } from 'sure-platform-sdk';

import copyConfig, { regionConfig } from '../constants/copyConfig';
import defaultWlConfig from '../constants/wlConfig';
import { TCopyConfig } from '../interfaces';

import { useWhitelabelConfig } from './useWhitelabelConfig';

type TCopyConfigContextValue = {
  copyConfig: TCopyConfig;
};

const getContextValue = (
  regionCode?: ERegionCode,
  config = copyConfig,
  wlConfig = defaultWlConfig
) => {
  const { hiddenCoverages = [] } = wlConfig;
  return {
    copyConfig: {
      ...config,
      addVehicleAddons: config.addVehicleAddons.filter(
        (addOn) => !hiddenCoverages.includes(addOn)
      ),
      vehicleAddons: config.vehicleAddons.filter(
        ({ key }) => !hiddenCoverages.includes(key)
      ),
    },
    wlConfig,
    regionCode,
  };
};

const CopyContext = createContext<TCopyConfigContextValue>(getContextValue());

export function useCopyConfig() {
  return useContext(CopyContext);
}

export function CopyConfigProvider({
  regionCode,
  children,
}: {
  regionCode?: ERegionCode;
  children: ReactNode;
}) {
  const { wlConfig } = useWhitelabelConfig();

  return (
    <CopyContext.Provider
      value={getContextValue(regionCode, regionConfig(regionCode), wlConfig)}
    >
      {children}
    </CopyContext.Provider>
  );
}
